import { MediaUpload } from "features/media/media.types"
import { GalleryMedium } from "features/gallery/gallery.types"
import { eventMediaApi } from "store/api"
import { EventMediumUpload, Post } from "suus-api"
import { DeletePostFunction } from "features/posts/form/post-form.types"

export async function addGalleryMediaToPost(
  postId: number,
  galleryUploads: MediaUpload[]
): Promise<GalleryMedium[]> {
  if (galleryUploads.length === 0) return []
  const response = await eventMediaApi.addEventMedia(
    postId.toString(),
    galleryUploads.map((galleryUpload) =>
      convertMediaUploadToDTO(galleryUpload)
    )
  )
  return response.data
}

export async function addGalleryMediaToCreatedPost(
  createdPost: Post,
  deletePost: DeletePostFunction,
  galleryMedia: MediaUpload[]
): Promise<GalleryMedium[]> {
  try {
    return await addGalleryMediaToPost(createdPost.id, galleryMedia)
  } catch (e) {
    console.error(e)
    return []
  }
}

function convertMediaUploadToDTO(upload: MediaUpload): EventMediumUpload {
  return {
    file_name: upload.file?.name,
    stored_file: upload.s3Key,
    content_type: upload.file?.type,
    width: upload.file?.width,
    height: upload.file?.height,
  }
}

export async function addGalleryMediaToUpdatedPost(
  updatedPost: Post,
  galleryMedia: MediaUpload[],
  existingGalleryMedia: GalleryMedium[] = []
): Promise<GalleryMedium[]> {
  return [
    ...(await addGalleryMediaToPost(updatedPost.id, galleryMedia)),
    ...existingGalleryMedia,
  ]
}

export async function deleteGalleryMedium(mediumId: number) {
  return await eventMediaApi.deleteEventMedium(mediumId.toString())
}
